<script lang="ts">
    import type { NumberSetting } from "..";

    export let setting: NumberSetting;

    const width = setting.max.toString().length;
</script>

<!----------------------------------------------------------------------------->

<input id={setting.id} type="number" bind:value={setting.value} style="--width: {width}ch" maxlength={width} min={setting.min} max={setting.max} step={setting.step}/>

<!----------------------------------------------------------------------------->

<style>
    input {
        width: calc(max(3ch, calc(var(--width))) + 4ch);
    }
</style>
